The opaque cursor to the webhook subscription.

This can be used as a subsequent pagination argument.
